"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var approve_1 = require("./contracts/dependencies/token/transactions/approve");
exports.approve = approve_1.approve;
var balanceOf_1 = require("./contracts/dependencies/token/calls/balanceOf");
exports.balanceOf = balanceOf_1.balanceOf;
var constructEnvironment_1 = require("./utils/environment/constructEnvironment");
exports.constructEnvironment = constructEnvironment_1.constructEnvironment;
var deploySystem_1 = require("./utils/deploy/deploySystem");
exports.deploySystem = deploySystem_1.deploySystem;
var deploySystem_2 = require("./utils/deploy/deploySystem");
exports.deployAllContractsConfig = deploySystem_2.deployAllContractsConfig;
var deployThirdParty_1 = require("./utils/deploy/deployThirdParty");
exports.deployThirdParty = deployThirdParty_1.deployThirdParty;
var executeRequest_1 = require("./contracts/fund/participation/transactions/executeRequest");
exports.executeRequest = executeRequest_1.executeRequest;
var cancelRequest_1 = require("./contracts/fund/participation/transactions/cancelRequest");
exports.cancelRequest = cancelRequest_1.cancelRequest;
var getFundDetails_1 = require("./contracts/factory/calls/getFundDetails");
exports.getFundDetails = getFundDetails_1.getFundDetails;
var getActiveOasisDexOrders_1 = require("./contracts/exchanges/calls/getActiveOasisDexOrders");
exports.getActiveOasisDexOrders = getActiveOasisDexOrders_1.getActiveOasisDexOrders;
var getFundHoldings_1 = require("./contracts/fund/accounting/calls/getFundHoldings");
exports.getFundHoldings = getFundHoldings_1.getFundHoldings;
var getHub_1 = require("./contracts/fund/hub/calls/getHub");
exports.getHub = getHub_1.getHub;
var getInfo_1 = require("./contracts/dependencies/token/calls/getInfo");
exports.getInfo = getInfo_1.getInfo;
var getManager_1 = require("./contracts/fund/hub/calls/getManager");
exports.getManager = getManager_1.getManager;
var getName_1 = require("./contracts/fund/hub/calls/getName");
exports.getName = getName_1.getName;
var getPrice_1 = require("./contracts/prices/calls/getPrice");
exports.getPrice = getPrice_1.getPrice;
var getPrices_1 = require("./contracts/prices/calls/getPrices");
exports.getPrices = getPrices_1.getPrices;
var getQuoteToken_1 = require("./contracts/prices/calls/getQuoteToken");
exports.getQuoteToken = getQuoteToken_1.getQuoteToken;
var getRoutes_1 = require("./contracts/fund/hub/calls/getRoutes");
exports.getRoutes = getRoutes_1.getRoutes;
var isShutDown_1 = require("./contracts/fund/hub/calls/isShutDown");
exports.isShutDown = isShutDown_1.isShutDown;
var getTokenBySymbol_1 = require("./utils/environment/getTokenBySymbol");
exports.getTokenBySymbol = getTokenBySymbol_1.getTokenBySymbol;
var getTokenByAddress_1 = require("./utils/environment/getTokenByAddress");
exports.getTokenByAddress = getTokenByAddress_1.getTokenByAddress;
var hasValidPrice_1 = require("./contracts/prices/calls/hasValidPrice");
exports.hasValidPrice = hasValidPrice_1.hasValidPrice;
var hasExpiredRequest_1 = require("./contracts/fund/participation/calls/hasExpiredRequest");
exports.hasExpiredRequest = hasExpiredRequest_1.hasExpiredRequest;
var isAddress_1 = require("./utils/checks/isAddress");
exports.isAddress = isAddress_1.isAddress;
var isEmptyAddress_1 = require("./utils/checks/isEmptyAddress");
exports.isEmptyAddress = isEmptyAddress_1.isEmptyAddress;
var childExists_1 = require("./contracts/factory/calls/childExists");
exports.childExists = childExists_1.childExists;
var managersToHubs_1 = require("./contracts/factory/calls/managersToHubs");
exports.managersToHubs = managersToHubs_1.managersToHubs;
var managersToSettings_1 = require("./contracts/factory/calls/managersToSettings");
exports.managersToSettings = managersToSettings_1.managersToSettings;
var managersToRoutes_1 = require("./contracts/factory/calls/managersToRoutes");
exports.managersToRoutes = managersToRoutes_1.managersToRoutes;
var performCalculations_1 = require("./contracts/fund/accounting/calls/performCalculations");
exports.performCalculations = performCalculations_1.performCalculations;
var requestInvestment_1 = require("./contracts/fund/participation/transactions/requestInvestment");
exports.requestInvestment = requestInvestment_1.requestInvestment;
var beginSetup_1 = require("./contracts/factory/transactions/beginSetup");
exports.beginSetup = beginSetup_1.beginSetup;
var completeSetup_1 = require("./contracts/factory/transactions/completeSetup");
exports.completeSetup = completeSetup_1.completeSetup;
var createAccounting_1 = require("./contracts/factory/transactions/createAccounting");
exports.createAccounting = createAccounting_1.createAccounting;
var createFeeManager_1 = require("./contracts/factory/transactions/createFeeManager");
exports.createFeeManager = createFeeManager_1.createFeeManager;
var createParticipation_1 = require("./contracts/factory/transactions/createParticipation");
exports.createParticipation = createParticipation_1.createParticipation;
var createPolicyManager_1 = require("./contracts/factory/transactions/createPolicyManager");
exports.createPolicyManager = createPolicyManager_1.createPolicyManager;
var createShares_1 = require("./contracts/factory/transactions/createShares");
exports.createShares = createShares_1.createShares;
var createTrading_1 = require("./contracts/factory/transactions/createTrading");
exports.createTrading = createTrading_1.createTrading;
var createVault_1 = require("./contracts/factory/transactions/createVault");
exports.createVault = createVault_1.createVault;
var shutDownFund_1 = require("./contracts/fund/hub/transactions/shutDownFund");
exports.shutDownFund = shutDownFund_1.shutDownFund;
var update_1 = require("./contracts/prices/transactions/update");
exports.update = update_1.update;
var triggerRewardAllFees_1 = require("./contracts/fund/fees/transactions/triggerRewardAllFees");
exports.triggerRewardAllFees = triggerRewardAllFees_1.triggerRewardAllFees;
var getDenominationAsset_1 = require("./contracts/fund/accounting/calls/getDenominationAsset");
exports.getDenominationAsset = getDenominationAsset_1.getDenominationAsset;
var makeOasisDexOrder_1 = require("./contracts/fund/trading/transactions/makeOasisDexOrder");
exports.makeOasisDexOrder = makeOasisDexOrder_1.makeOasisDexOrder;
var withDifferentAccount_1 = require("./utils/environment/withDifferentAccount");
exports.withDifferentAccount = withDifferentAccount_1.withDifferentAccount;
var getHistoricalInvestors_1 = require("./contracts/fund/participation/calls/getHistoricalInvestors");
exports.getHistoricalInvestors = getHistoricalInvestors_1.getHistoricalInvestors;
var getAmguPrice_1 = require("./contracts/engine/calls/getAmguPrice");
exports.getAmguPrice = getAmguPrice_1.getAmguPrice;
var getEnginePrice_1 = require("./contracts/engine/calls/getEnginePrice");
exports.getEnginePrice = getEnginePrice_1.getEnginePrice;
var getTotalAmguConsumed_1 = require("./contracts/engine/calls/getTotalAmguConsumed");
exports.getTotalAmguConsumed = getTotalAmguConsumed_1.getTotalAmguConsumed;
var getTotalEtherConsumed_1 = require("./contracts/engine/calls/getTotalEtherConsumed");
exports.getTotalEtherConsumed = getTotalEtherConsumed_1.getTotalEtherConsumed;
var getLiquidEther_1 = require("./contracts/engine/calls/getLiquidEther");
exports.getLiquidEther = getLiquidEther_1.getLiquidEther;
var getFrozenEther_1 = require("./contracts/engine/calls/getFrozenEther");
exports.getFrozenEther = getFrozenEther_1.getFrozenEther;
var getPremiumPercent_1 = require("./contracts/engine/calls/getPremiumPercent");
exports.getPremiumPercent = getPremiumPercent_1.getPremiumPercent;
var getTotalMlnBurned_1 = require("./contracts/engine/calls/getTotalMlnBurned");
exports.getTotalMlnBurned = getTotalMlnBurned_1.getTotalMlnBurned;
var cancelOasisDexOrder_1 = require("./contracts/fund/trading/transactions/cancelOasisDexOrder");
exports.cancelOasisDexOrder = cancelOasisDexOrder_1.cancelOasisDexOrder;
var deployContract_1 = require("./utils/solidity/deployContract");
exports.deployContract = deployContract_1.deployContract;
var getFundComponents_1 = require("./utils/getFundComponents");
exports.getFundComponents = getFundComponents_1.getFundComponents;
var FunctionSignatures_1 = require("./contracts/fund/trading/utils/FunctionSignatures");
exports.FunctionSignatures = FunctionSignatures_1.FunctionSignatures;
var Contracts_1 = require("./Contracts");
exports.Exchanges = Contracts_1.Exchanges;
exports.Contracts = Contracts_1.Contracts;
var register_1 = require("./contracts/fund/policies/transactions/register");
exports.register = register_1.register;
var createOrder_1 = require("./contracts/exchanges/third-party/0x/utils/createOrder");
exports.createOrder = createOrder_1.createOrder;
exports.approveOrder = createOrder_1.approveOrder;
exports.isValidSignatureOffChain = createOrder_1.isValidSignatureOffChain;
var getWrapperLock_1 = require("./contracts/exchanges/third-party/ethfinex/calls/getWrapperLock");
exports.getWrapperLock = getWrapperLock_1.getWrapperLock;
var withPrivateKeySigner_1 = require("./utils/environment/withPrivateKeySigner");
exports.withPrivateKeySigner = withPrivateKeySigner_1.withPrivateKeySigner;
var withNewAccount_1 = require("./utils/environment/withNewAccount");
exports.withNewAccount = withNewAccount_1.withNewAccount;
var sendEth_1 = require("./utils/evm/sendEth");
exports.sendEth = sendEth_1.sendEth;
var deposit_1 = require("./contracts/dependencies/token/transactions/deposit");
exports.deposit = deposit_1.deposit;
var withdraw_1 = require("./contracts/dependencies/token/transactions/withdraw");
exports.withdraw = withdraw_1.withdraw;
var randomString_1 = require("./utils/helpers/randomString");
exports.randomString = randomString_1.randomString;
var makeOrderFromAccountOasisDex_1 = require("./contracts/exchanges/transactions/makeOrderFromAccountOasisDex");
exports.makeOrderFromAccountOasisDex = makeOrderFromAccountOasisDex_1.makeOrderFromAccountOasisDex;
var takeOasisDexOrder_1 = require("./contracts/fund/trading/transactions/takeOasisDexOrder");
exports.takeOasisDexOrder = takeOasisDexOrder_1.takeOasisDexOrder;
var takeEngineOrder_1 = require("./contracts/fund/trading/transactions/takeEngineOrder");
exports.takeEngineOrder = takeEngineOrder_1.takeEngineOrder;
var getOasisDexOrder_1 = require("./contracts/exchanges/calls/getOasisDexOrder");
exports.getOasisDexOrder = getOasisDexOrder_1.getOasisDexOrder;
var getExpectedRate_1 = require("./contracts/exchanges/third-party/kyber/calls/getExpectedRate");
exports.getExpectedRate = getExpectedRate_1.getExpectedRate;
var takeOrderOnKyber_1 = require("./contracts/fund/trading/transactions/takeOrderOnKyber");
exports.takeOrderOnKyber = takeOrderOnKyber_1.takeOrderOnKyber;
var getFundOpenOrder_1 = require("./contracts/fund/trading/calls/getFundOpenOrder");
exports.getFundOpenOrder = getFundOpenOrder_1.getFundOpenOrder;
var getOpenOrders_1 = require("./contracts/fund/trading/calls/getOpenOrders");
exports.getOpenOrders = getOpenOrders_1.getOpenOrders;
var chainName_1 = require("./utils/environment/chainName");
exports.getChainName = chainName_1.getChainName;
var signOrder_1 = require("./contracts/exchanges/third-party/0x/utils/signOrder");
exports.signOrder = signOrder_1.signOrder;
var stringifyStruct_1 = require("./utils/solidity/stringifyStruct");
exports.stringifyStruct = stringifyStruct_1.stringifyStruct;
var take0xOrder_1 = require("./contracts/fund/trading/transactions/take0xOrder");
exports.take0xOrder = take0xOrder_1.take0xOrder;
var make0xOrder_1 = require("./contracts/fund/trading/transactions/make0xOrder");
exports.make0xOrder = make0xOrder_1.make0xOrder;
var cancel0xOrder_1 = require("./contracts/fund/trading/transactions/cancel0xOrder");
exports.cancel0xOrder = cancel0xOrder_1.cancel0xOrder;
var makeEthfinexOrder_1 = require("./contracts/fund/trading/transactions/makeEthfinexOrder");
exports.makeEthfinexOrder = makeEthfinexOrder_1.makeEthfinexOrder;
var cancelEthfinexOrder_1 = require("./contracts/fund/trading/transactions/cancelEthfinexOrder");
exports.cancelEthfinexOrder = cancelEthfinexOrder_1.cancelEthfinexOrder;
var getRequest_1 = require("./contracts/fund/participation/calls/getRequest");
exports.getRequest = getRequest_1.getRequest;
var hasValidRequest_1 = require("./contracts/fund/participation/calls/hasValidRequest");
exports.hasValidRequest = hasValidRequest_1.hasValidRequest;
var getFundToken_1 = require("./contracts/fund/hub/calls/getFundToken");
exports.getFundToken = getFundToken_1.getFundToken;
var redeemQuantity_1 = require("./contracts/fund/participation/transactions/redeemQuantity");
exports.redeemQuantity = redeemQuantity_1.redeemQuantity;
var getToken_1 = require("./contracts/dependencies/token/calls/getToken");
exports.getToken = getToken_1.getToken;
var getAllowedExchanges_1 = require("./contracts/fund/trading/calls/getAllowedExchanges");
exports.getAllowedExchanges = getAllowedExchanges_1.getAllowedExchanges;
var enableInvestment_1 = require("./contracts/fund/participation/transactions/enableInvestment");
exports.enableInvestment = enableInvestment_1.enableInvestment;
var disableInvestment_1 = require("./contracts/fund/participation/transactions/disableInvestment");
exports.disableInvestment = disableInvestment_1.disableInvestment;
var investAllowed_1 = require("./contracts/fund/participation/calls/investAllowed");
exports.investAllowed = investAllowed_1.investAllowed;
var getPolicyInformation_1 = require("./contracts/fund/policies/calls/getPolicyInformation");
exports.getPolicyInformation = getPolicyInformation_1.getPolicyInformation;
var getShareCostInAsset_1 = require("./contracts/fund/accounting/calls/getShareCostInAsset");
exports.getShareCostInAsset = getShareCostInAsset_1.getShareCostInAsset;
var getManagementFee_1 = require("./contracts/fund/fees/calls/getManagementFee");
exports.getManagementFee = getManagementFee_1.getManagementFee;
var getPerformanceFee_1 = require("./contracts/fund/fees/calls/getPerformanceFee");
exports.getPerformanceFee = getPerformanceFee_1.getPerformanceFee;
var getLastUpdate_1 = require("./contracts/prices/calls/getLastUpdate");
exports.getLastUpdate = getLastUpdate_1.getLastUpdate;
